import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IAgencyAdmin } from '../interfaces/agency-admin';
import { IAddAdmin } from '../interfaces/add-admin';
import { IUpdateAdmin } from '../interfaces/update-admin';

@Injectable({
  providedIn: 'root'
})
export class AgencyAdminService {
  private rootUrl: string = "/api/agency-admins";

  constructor(private httpClient: HttpClient) { }

  public getAgencyAdmins(appId: number, agencyId: number): Observable<IAgencyAdmin[]> {
    const url = this.rootUrl + "?appId=" + appId + "&agencyId=" + agencyId;
    return this.httpClient.get<IAgencyAdmin[]>(url);
  }

  public addAgencyAdmin(appId: number, emailAppId: number, agencyId: number, addAgencyAdmin: IAddAdmin): Observable<string> {
    const url = this.rootUrl + "?appId=" + appId + "&emailAppId=" + emailAppId + "&agencyId=" + agencyId;
    return this.httpClient.post<string>(url, addAgencyAdmin);
  }

  public addAgencyAdminFromExisting(appId: number, agencyId: number, id: string, allowLogin: boolean) {
    const url = this.rootUrl + "/from-existing?appId=" + appId + "&agencyId=" + agencyId + "&id=" + id + "&allowLogin=" + allowLogin;
    return this.httpClient.post(url, null);
  }

  public updateAgencyAdmin(id: string, appId: number, updateAgencyAdmin: IUpdateAdmin) {
    const url = this.rootUrl + "/" + id + "?appId=" + appId;
    return this.httpClient.put(url, updateAgencyAdmin);
  }

  public removeAgencyAdmin(appId: number, agencyId: number, id: string) {
    const url = this.rootUrl + "/" + id + "?appId=" + appId + "&agencyId=" + agencyId;
    return this.httpClient.delete(url);
  }
}
